// The areas, in order — the same order Arbejdskø's own tab strip uses (see AREA_LABEL/AREA_TAB_LABEL/
// AREA_ICON in areaLabels.js), so the two pages never mean different area lists. Konfiguration drops
// 'licenses' (a subscription, not a setup) — see CONFIG_AREAS in configModel.js.
export const SETTINGS_AREA_ORDER = ['identity', 'devices', 'security', 'exchange', 'sharepoint', 'applications', 'roles', 'conditional-access', 'licenses'];
